export default __webpack_public_path__ + "static/11-bab98d0cc966cc96615a036b8e7c9fde.png";